import { createAction } from 'redux-actions';

export const SetRedirectControl = createAction('SET_REDIRECT_CONTROL');
